import { TableColumnHeader } from "@/components/shared/table/Table";
import { Button } from "@/components/ui/button";
import { SocialSecurity } from "@/graphql/__generated__/graphql";
import { convertBpToDecimal, formatDateLocale } from "@/utils/helpers";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { TrashIcon } from "lucide-react";
import { IntlShape } from "react-intl";

export const getColumnsSocialSecurity = (
  intl: IntlShape,
  t: TFunction,
  handleRemoveSocialSecurity: (_socialSecurity: SocialSecurity) => void,
  isConfigAdmin: boolean,
): ColumnDef<SocialSecurity>[] => [
  {
    id: "activeFrom",
    accessorKey: "activeFrom",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:socialsecurity.columns.activationdate")}
        column={column}
      />
    ),
    cell: ({ row }) => {
      const activeFrom = new Date(row.getValue("activeFrom"));
      return <div>{formatDateLocale(intl, activeFrom)}</div>;
    }
  },
  {
    id: "value",
    accessorKey: "value",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:socialsecurity.columns.value")}
        column={column}
        align="end"
      />
    ),
    cell: ({ row }) => {
      const value = parseFloat(row.getValue("value"));
      return <div className="text-right font-medium">{convertBpToDecimal(value)}%</div>;
    }
  },
  ...(isConfigAdmin
    ? [
      {
        accessorKey: "actions",
        size: 40,
        header: () => <div className="flex justify-end"></div>,
        cell: ({ row }) => (
          <div className="flex gap-2 justify-end">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleRemoveSocialSecurity(row.original)}
            >
              <TrashIcon className="w-4 h-4 text-red-500" />
            </Button>
          </div>
        ),
      },
    ]
    : []),
];
